import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { DISTRESS_STATUS_OPTIONS } from 'utils/constants/distressStatus';

export const filters = ({
  bizClients,
  minDate = undefined,
  userAssignedDepartments = [],
}) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);
  return {
    RegularFilters: [
      {
        label: 'status',
        field: 'status',
        type: 'select',
        options: DISTRESS_STATUS_OPTIONS,
        multiple: true,
        placeholder: '',
      },
      {
        label: 'businessClient',
        field: 'businessClient',
        type: 'select',
        options: bizClients,
      },
      {
        label: 'dateFrom',
        field: 'dateFrom',
        type: 'date-picker',
      },
      {
        label: 'dateTo',
        field: 'dateTo',
        type: 'date-picker',
        minDate,
      },
    ],
    AdvancedFilters: [...departmentFilterField],
  };
};
